
import * as Lang from "@/i18n/lang";
import { defineComponent } from "vue";
import WideCard from "@/components/global/WideCard.vue";
import * as Snackbars from "@/utils/Snackbars";
import * as DOMUtils from "@/utils/DOMUtils";
import { getAttachmentManager } from "@/firebase/AttachmentManager";
import Attachment from "@/model/Filesystem/Attachment";
import * as UploadManager from "@/model/Uploads/UploadManager";
import * as Modals from "@/utils/Modals";
import { getCommunicationsState } from "@/pinia/communications/CommunicationsState";
import CommunicationTargetRole from "@/components/communication/CommunicationTargetRole.vue";
import { getTrainingsState } from "@/pinia/trainings/TrainingsState";
import TrainingQuiz from "@/components/trainings/TrainingQuiz.vue";
import { getTrainingState } from "@/pinia/trainings/TrainingState";
import TrainingTargetStore from "@/components/trainings/TrainingTargetStore.vue";
import TrainingTargetRole from "@/components/trainings/TrainingTargetRole.vue";
import TrainingSection from "@/model/Trainings/TrainingSection";
import Quiz from "@/model/Communication/Quiz";
import SeFadeButton from "@/components/global/SeFadeButton.vue";
import SeDropdown from "@/components/global/dropdown/SeDropdown.vue";
import SeDropdownItem from "@/components/global/dropdown/SeDropdownItem.vue";
import TrainingCategory from "@/model/Trainings/TrainingCategory";
import SeButton from "@/components/global/SeButton.vue";
import { collection, doc } from "firebase/firestore";
import * as Firebase from "@/firebase/Firebase"
import ToggleSwitch from "@/components/global/ToggleSwitch.vue";

export default defineComponent({
  async setup() {
    let state = getTrainingState();

    await state.setup();
    return {
      state: state,
    };
  },
  data() {
    return {
      categoryName: "",
      Lang: Lang,
    };
  },

  mounted() {

    if (this.state.training.category != null) {
      this.state.selectedCategory = this.state.categories.find(x => x.ref.id == this.state.training.category.id);

    }
    else {
      this.state.selectedCategory = null;
    }
  },
  methods: {

    openRoleFilterModal() {
      var refs = <any>this.$refs;
      refs.targetRole.displayFilters();
      refs.roleFilterModal.open();
    },
    closeRoleFilterModal() {
      var refs = <any>this.$refs;
      refs.targetRole.applyFilters();
      refs.roleFilterModal.close();
    },

    createCategory() {
      var cat = new TrainingCategory(
        doc(
          collection(Firebase.firestore, "training_categories")
        ), this.categoryName, this.state.training.source, this.state.training.type)

      cat.set();

      this.state.categories.push(cat);
      var refs = <any>this.$refs;
      refs.categoryModal.close();

    },
    openCategoryModal() {
      var refs = <any>this.$refs;
      refs.categoryModal.open();
    },
    deleteSection(section: TrainingSection) {
      const index = this.state.training.sections.indexOf(section);
      this.state.training.sections.splice(index, 1);
    },
    sectionClick(section: TrainingSection) {
      this.state.selectedSection = section;

      if (section.quiz.questions.length > 0)
        this.state.selectedQuestion = section.quiz.questions[0];
      else this.state.selectedQuestion = null;
    },
    addSection() {
      this.state.training.sections.push(
        new TrainingSection("Nouvelle section", new Quiz([]), null)
      );
    },
    downloadAttachment() {
      this.state.selectedSection?.attachment?.download();
    },

    openStoreFilterModal() {
      var refs = <any>this.$refs;
      refs.targetStore.displayFilters();
      refs.storeFilterModal.open();
    },
    closeStoreFilterModal() {
      var refs = <any>this.$refs;
      refs.targetStore.applyFilters();
      refs.storeFilterModal.close();
    },
    uploadAttachment() {
      DOMUtils.attachementFileDialog(this.onAttachmentUploaded);
    },
    async onAttachmentUploaded(e: any) {
      let file = e.target.files[0];

      var path =
        "/databases/" +
        this.state.database?.ref.id! +
        "/training/" +
        this.state.training?.ref.id!;

      var strategy = await UploadManager.createStrategy(file, path, true);

      UploadManager.addFileToUpload(strategy);

      this.state.selectedSection!.attachment = strategy.generateAttachment()!;
    },

    async update() {

      if (this.state.selectedSection?.attachment == null) {
        Modals.open("Please select an attachment for this training.");
        return;
      }

      for (let section of this.state.training.sections) {
        for (let question of section.quiz!.questions) {
          if (
            question.answers.length == 0 ||
            !question.answers.some((x) => x.correct)
          ) {
            Modals.open(
              "Veuillez selectionner au moins une bonne réponse pour chaque quiz."
            );
            return;
          }
        }
      }


      if (this.state.selectedCategory != null) {
        this.state.training.category = this.state.selectedCategory.ref;
      }
      else {
        this.state.training.category = null;
      }

      await UploadManager.applyUploads();

      for (let section of this.state.training.sections) {
        if (section.attachment) {
          await section.attachment.generateUrl();
        }
      }

      await this.state.training?.set();

      if (this.state.creation) {
        getTrainingsState().trainings.push(this.state.training);
      }

      Snackbars.display(Lang.getI18N("saved-successfully"));
    },
  },
  components: {
    WideCard,
    TrainingQuiz,
    TrainingTargetStore,
    TrainingTargetRole,
  },
});
